/* angular:styles/component:scss;88032c3447dffebed5fc8bd05ecd87427bb0da0f52cf9bee74a8927ed8770b25;/home/vsts/work/1/s/Autocare.Api/ClientApp/src/app/module/users/types/formly-field-date-range.component.ts */
::ng-deep .p-inputgroup-addon {
  background: #fff !important;
}
::ng-deep .p-inputgroup-addon:hover {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
.formly-validation-message {
  color: #e24c4c;
  font-size: 13px;
  margin-top: 4px;
  font-weight: 500;
}
/*# sourceMappingURL=formly-field-date-range.component-THEU5FEI.css.map */
